import React, { memo } from 'react';
import NumberedAccordions from '../Number/NumberedAccordions';
import AccordionWrapper from '../Accordion/AccordionWrapper';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import ListWrapper from '../List/ListsWrapper';
import { areQuestionsEqual } from '../../../../../hooks/useQuestions';

export type Props = {
  filteredQuestions: QuestionEntry[];
  numberLayout?: boolean;
  accordionLayout?: boolean;
  listLayout?: boolean;
};

const DEFAULT_ACCORDION_LAYOUT = true;

const SelectedLayout = memo(
  ({
    filteredQuestions,
    numberLayout = false,
    accordionLayout = DEFAULT_ACCORDION_LAYOUT,
    listLayout = false,
  }: Props) => {
    return (
      <>
        {numberLayout && (
          <NumberedAccordions filteredQuestions={filteredQuestions} />
        )}
        {listLayout && <ListWrapper filteredQuestions={filteredQuestions} />}
        {accordionLayout && (
          <AccordionWrapper filteredQuestions={filteredQuestions} />
        )}
      </>
    );
  },
  (prev, next) =>
    areQuestionsEqual(prev.filteredQuestions, next.filteredQuestions) &&
    prev.numberLayout === next.numberLayout &&
    prev.accordionLayout === next.accordionLayout &&
    prev.listLayout === next.listLayout,
);

SelectedLayout.displayName = 'SelectedLayout';

export default SelectedLayout;
